import { Fragment } from 'react'

import { Kbd } from './Kbd'

import styles from './ShortcutsDialog.module.scss'

import DialogWrapper from '@/components/Dialog'

const SHORTCUTS: Array<[string, string]> = [
  ['⏎', 'Accept the turn as shown and move to the next'],
  ['1-9, then Q W T Y I O P F H L C V B M', 'Assign speaker by hotkey'],
  ['U', 'Label the turn Unknown speaker'],
  ['X', 'Label the turn Echo'],
  ['D', 'Delete'],
  ['⌫ / Delete', 'Clear state; with roster speakers ticked, delete them'],
  ['Click a transcript speaker name', 'Assign this turn to another speaker'],
  ['Double-click a roster speaker', 'Delete the speaker'],
  ['E / double-click', 'Edit turn text: ⏎ saves, ⇧⏎ splits at the cursor, ⌘⏎ saves, Esc cancels'],
  ['S', 'Split turn: place the cursor, then ⏎ splits there (click away or Esc cancels)'],
  ['A', 'Add a speaker to the roster'],
  [
    'G',
    'Name or remove a room voice; rename or join an existing room as a person. With multiple speakers selected, group them into a room',
  ],
  ['⌘ / Ctrl + click', 'Select speakers from transcript rows for room grouping (click again to deselect)'],
  ['N', 'Add note'],
  ['F2', 'Edit (rename or delete) speaker'],
  ['Z / ⌘Z', 'Undo'],
  ['⇧Z / ⌘⇧Z', 'Redo'],
  ['↑ / ↓ or K / J', 'Move between turns; leaving an unreviewed turn accepts it'],
  ['Space', 'Play / pause'],
  ['← / → (tap)', 'Jump to the previous / next keyword, block ending, or turn start'],
  ['← / → (hold)', 'Scrub back / forward through the turn at 3×'],
  ['R', 'Restart clip'],
  ['⌘S', 'Save now'],
  ['?', 'Show shortcuts'],
]

export interface ShortcutsDialogProps {
  isOpen: boolean
  close: () => void
}

export const ShortcutsDialog = ({ isOpen, close }: ShortcutsDialogProps) => (
  <DialogWrapper isOpen={isOpen} title="Keyboard shortcuts" close={close}>
    <div className={styles.list}>
      {SHORTCUTS.map(([key, label]) => (
        <Fragment key={key}>
          <Kbd>{key}</Kbd>
          <span className={styles.label}>{label}</span>
        </Fragment>
      ))}
    </div>
    <p className={styles.note}>Finalize has no shortcut — use the button in the header.</p>
  </DialogWrapper>
)
